import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core"
import { Button } from "components"
import { StatusActions } from "types";

const ActiveStatusActions = ({ onClick, isLoading }: StatusActions) => {
  const { t } = useTranslation();

  return (
    <Box ml={'sm'}>
      <Button size={'compact-md'} color={'var(--mantine-color-grape-7)'} onClick={() => onClick('SETTLED')} loading={isLoading}>
        {t('credit.status.action.SETTLED')}
      </Button>
    </Box>
  )
}

export default ActiveStatusActions;